import React from 'react';
import { 
  Box, 
  Container, 
  VStack, 
  Heading, 
  Text, 
  Button, 
  useColorModeValue,
  Stat,
  StatLabel,
  StatNumber,
  StatGroup,
  Divider
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../../context/GameContext';
import { useWordTracker } from '../../context/WordTrackerContext';

const GameOver = () => {
  const { score, resetGame, resetSessionLives, setScore } = useGame();
  const { resetAll } = useWordTracker();
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  
  const handlePlayAgain = () => {
    resetGame();
    resetSessionLives();
    resetAll();
    setScore(0);
    navigate('/');
  };

  return (
    <Container maxW="container.md" py={8}>
      <VStack spacing={6} align="stretch">
        <Box 
          p={8} 
          bg={bgColor} 
          borderRadius="lg" 
          boxShadow="xl"
          borderWidth="1px"
          borderColor={borderColor}
        >
          <VStack spacing={6}>
            <Heading 
              as="h1" 
              size="xl" 
              bgGradient="linear(to-r, red.500, red.300)" 
              bgClip="text"
            >
              Game Over
            </Heading>
            
            <Text fontSize="lg" color="gray.600" textAlign="center">
              You've used all your lives! Better luck next time!
            </Text>
            
            <StatGroup>
              <Stat textAlign="center">
                <StatLabel>Final Score</StatLabel>
                <StatNumber>{score}</StatNumber>
              </Stat>
            </StatGroup>
            
            <Divider />
            
            <Button
              colorScheme="blue"
              size="lg"
              onClick={handlePlayAgain}
            >
              Play Again
            </Button>
          </VStack>
        </Box>
      </VStack>
    </Container>
  );
};

export default GameOver; 